// extracted by mini-css-extract-plugin
export var infoItem = "_rm-2";
export var title = "_rm-0";
export var value = "_rm-1";